import {use, createContext, memo} from 'react'

import useBannersStore from './BannersContext.hooks'
import type {BannersContextProps, BannersProviderProps} from './BannersContext.types'

const BannersContext = createContext<BannersContextProps>({} as BannersContextProps)

function BannersProvider({children}: BannersProviderProps) {
  const store = useBannersStore()

  return <BannersContext value={store}>{children}</BannersContext>
}

export default memo(BannersProvider)

export const useBanners = (): BannersContextProps => use(BannersContext)
